import { createSlice } from "@reduxjs/toolkit";
const menuSlice = createSlice({
	name: 'menuData',
	initialState: {
		data: null,
	},
	reducers: {
		setData: (state, { payload }) => {
			state.data = payload;
		},
	}
});
export const { setData } = menuSlice.actions;
export default menuSlice.reducer;
